const initialPatientValues = {
  User: {
    FirstName: "",
    MiddleName: "",
    FamilyName: "",
    MotherName: "" || undefined,
    // Username: "",
    BloodType: "Unknown",
    Gender: "Unspecified",
    MaritalStatus: "Unspecified",
    DateOfBirth: "",
    PhotoURI:undefined,
    // Password: "",
    // PasswordConfirmed: "",
    Address: {
      Street: "",
      Additional: "",
      City: "",
      Zip: "",
      CountryCode: "",
    },
    Contact: {
      PrimaryEmail: {
        Email: "",
      },
      SecondaryEmail: undefined,
      PrimaryPhone: {
        Phone: "",
        CountryCode: "",
      },
      SecondaryPhone: undefined,
    },
    Insurance: {
      InsuranceNb: "",
      InsuranceCompany: "",
      InsuranceCountry: "",
      InsurancePolicy: "",
      IssuedDate: "",
      ExpiryDate: "",
      InsuranceIDImageURI: "",
      Active: false
    },
    Identity: undefined
  },
  Patient: {
    CriticNotes: [],
    Allergies: [],
    ChronicDiseases: [],
    Height: undefined,
    Weight: undefined,
  },
};
export default initialPatientValues;
